export default __webpack_public_path__ + "static/media/institution_login.84f2ca36.svg";